
// Related articles for the armpit pain article
export const armpitPainRelatedArticles = [
  {
    id: "armpit-health-basics",
    slug: "armpit-health-basics",
    title: "Armpit Health: The Basics Everyone Should Know"
  },
  {
    id: "armpit-pain-lymph-nodes",
    slug: "armpit-pain-lymph-nodes-swelling-causes",
    title: "Armpit Pain and Lymph Node Swelling: Causes and When to Worry"
  },
  {
    id: "underarm-rash-remedies",
    slug: "effective-remedies-underarm-rash",
    title: "5 Effective Remedies for Underarm Rash"
  }
];
